import { Box, Button, Checkbox, useTheme } from '@mui/material'
import React from 'react'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import IconButton from '@mui/material/IconButton'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { focusElemnt, navigation1 } from '../../common/helper'
import { RefreshSvg } from '../../common/svg/refresh'
import { useEffect } from 'react'
import { useRef } from 'react'
import DropDownMultiSelectV2 from '../../common/dropDownMultiSelectV2'
import { useAtom } from 'jotai'
import { destinationCityListAtom, sourceCityAtom, sourceCityListAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
import { destinationCityAtom } from '../../common/jotaiState/deliverymemoStateAtoms'


const DeliveryMemoFilter = (props) => {
  const [sourceCity, setSourceCity] = useAtom(sourceCityAtom)
  const [destinationCity, setDestinationCity] = useAtom(destinationCityAtom) 
  const [sourceCityListData] = useAtom(sourceCityListAtom)
  const [destinationCityListData] = useAtom(destinationCityListAtom) 
  const { memoFilterData, memoFilterMethods } = props
  const {  memoFromDate, memoToDate, moreFilter,} = memoFilterData
  const { showMore, tillDate, showAll, resetFilter, resetMainFilter,paymentTypeListData, challanNoListData,lrNoListData, offlineLrNoListData, senderListData  } = memoFilterData
  const { senderMobileNoListData, senderGSTNListData, senderEmailIDListData, recNameListData, recMobileNoListData, receiverEmailIDListData, receiverGSTNListData, pinCodeListData } = memoFilterData
  const { setPaymentListData, setChallanNoListData, setMemoFromDate, setMemoToDate, setMoreFilter, setAppliedMoreFilter, setShowMore, setTillDate, setShowAll, setResetFilter,setIsPdfLoaded, setIsExpanded } = memoFilterMethods
  const { setLrNoListData, setOfflineLrNoListData, setSenderListData, setSenderMobileNoListData, setSenderGSTNListData, setSenderEmailIDListData, setRecNameListData, setRecMobileNoListData } = memoFilterMethods
  const { setReceiverEmailIDListData, setReceiverGSTNListData, setPinCodeListData } = memoFilterMethods
  const { handleGenerate, tableData,setTableData, setIsShowAllLRs, deliveryMemoData, filters, setFilterHeight, getTableInfo, getFilter } = props
  const theme = useTheme()
  const { palette: cs } = theme
  
  const handleToggle = () => {
    setShowMore(!showMore)
  }
  const ref = useRef(null);
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      // Get the latest height of the child component
      const { height } = entries[0].contentRect;
      // Notify the parent about the height change
      setFilterHeight(height);
    });

    observer.observe(ref.current);

    // Cleanup the observer on component unmount
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (tableData?.length !== 0) {
      const PaymentTypeData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.PaymentType)) {
          acc.set.add(current.PaymentType)
          acc.list=[...acc.list,{dataKey:current.PaymentType,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setPaymentListData(PaymentTypeData)
      // setPaymentListData(filterData(tableData, 'PaymentType'))
      const ChallanNoData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.ChallanNo)) {
          acc.set.add(current.ChallanNo)
          acc.list=[...acc.list,{dataKey:current.ChallanNo,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setChallanNoListData(ChallanNoData)
      // setChallanNoListData(filterData(tableData, 'ChallanNo'))
      const LRNOData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.LRNO)) {
          acc.set.add(current.LRNO)
          acc.list=[...acc.list,{dataKey:current.LRNO,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setLrNoListData(LRNOData)
      // setLrNoListData(filterData(tableData, 'LRNO'))
      const ManualLRNoData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.ManualLRNo)) {
          acc.set.add(current.ManualLRNo)
          acc.list=[...acc.list,{dataKey:current.ManualLRNo,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setOfflineLrNoListData(ManualLRNoData)
      // setOfflineLrNoListData(filterData(tableData, 'ManualLRNo'))
      const SenderData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.Sender)) {
          acc.set.add(current.Sender)
          acc.list=[...acc.list,{dataKey:current.Sender,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setSenderListData(SenderData)
      // setSenderListData(filterData(tableData, 'Sender'))
      const SenderMobileNoData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.SenderMobileNo)) {
          acc.set.add(current.SenderMobileNo)
          acc.list=[...acc.list,{dataKey:current.SenderMobileNo,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setSenderMobileNoListData(SenderMobileNoData)
      // setSenderMobileNoListData(filterData(tableData, 'SenderMobileNo'))
      const SenderGSTNData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.SenderGSTN)) {
          acc.set.add(current.SenderGSTN)
          acc.list=[...acc.list,{dataKey:current.SenderGSTN,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setSenderGSTNListData(SenderGSTNData)
      // setSenderGSTNListData(filterData(tableData, 'SenderGSTN'))
      const SenderEmailIDData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.SenderEmailID)) {
          acc.set.add(current.SenderEmailID)
          acc.list=[...acc.list,{dataKey:current.SenderEmailID,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setSenderEmailIDListData(SenderEmailIDData)
      // setSenderEmailIDListData(filterData(tableData, 'SenderEmailID'))
      const reacNameData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.RecName)) {
          acc.set.add(current.RecName)
          acc.list=[...acc.list,{dataKey:current.RecName,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setRecNameListData(reacNameData)
      // setRecNameListData(filterData(tableData, 'RecName'))
      const reacNoData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.RecMobileNo)) {
          acc.set.add(current.RecMobileNo)
          acc.list=[...acc.list,{dataKey:current.RecMobileNo,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      // setRecMobileNoListData(filterData(tableData, 'RecMobileNo'))
      setRecMobileNoListData(reacNoData)
      const ReceiverEmailIDData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.ReceiverEmailID)) {
          acc.set.add(current.ReceiverEmailID)
          acc.list=[...acc.list,{dataKey:current.ReceiverEmailID,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setReceiverEmailIDListData(ReceiverEmailIDData)
      // setReceiverEmailIDListData(filterData(tableData, 'ReceiverEmailID'))
      const ReceiverGSTNData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.ReceiverGSTN)) {
          acc.set.add(current.ReceiverGSTN)
          acc.list=[...acc.list,{dataKey:current.ReceiverGSTN,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setReceiverGSTNListData(ReceiverGSTNData)
      // setReceiverGSTNListData(filterData(tableData, 'ReceiverGSTN'))
      const ReceiverPinData=tableData.reduce((acc,current,index)=>{
        if (!acc.set.has(current.ReceiverPin)) {
          acc.set.add(current.ReceiverPin)
          acc.list=[...acc.list,{dataKey:current.ReceiverPin,idKey:index+1}]
        }
        return acc
      },{set:new Set(),list:[]}).list
      setPinCodeListData(ReceiverPinData)
      // setPinCodeListData(filterData(tableData, 'ReceiverPin'))
    }
  }, [tableData])

  useEffect(() => {
    setIsPdfLoaded(false)
  }, [moreFilter, memoFromDate, memoToDate, showAll, tillDate])

  useEffect(() => {
    focusElemnt('memoFromDate')
  }, [])
  const filterTableData = () => {
    let newData = {}
    for (let key in moreFilter) {
      if (moreFilter[key] !== '') {
        if (Array.isArray(moreFilter[key]) && moreFilter[key].length) {
          newData[key]=moreFilter[key].map((a)=>a.dataKey).join(',')
        }else{
          newData[key] = moreFilter[key]
        }
      }
    }
    setAppliedMoreFilter(newData);
    let result = tableData.filter(filterOptions)
    let newResult = getTableInfo(result)
    setTableData(newResult)
  }
  const filterOptions = (item) => {
    for (const property in moreFilter) {
      const selectedValue = moreFilter[property]
      if (Array.isArray(selectedValue) && selectedValue.length) {
        const newSet =new Set(selectedValue.map((i)=>i.dataKey))
        if (!newSet.has(item[property])) {
          return
        }
      } else if (selectedValue !== '' && item[property] !== selectedValue && !Array.isArray(selectedValue)) {
        return
      }
    }
    return item
  }
  
  const resetMoreFilter = () => {
    setResetFilter(false);
    setTimeout(() => {
      setResetFilter(true)
    }, 50);
    setMoreFilter(filters);
    let newData = getTableInfo(deliveryMemoData)
    setTableData(newData);
    setAppliedMoreFilter({});
    setIsPdfLoaded([])
  }

  return (
    <Box sx={{ background: '#fff' }} ref={ref}>
      <Box sx={{ ...sx.reportFlex,paddingLeft:'15px', justifyContent: 'start', paddingBottom: '12px',flexWrap:'nowrap' }}>
        <Item sx={{...sx.itemsxGrow, width:'14%'}} className="input--container bookingDatePicker">
          <Datepicker
            id="memoFromDate"
            width="100%"
            value={memoFromDate}
            statusChecked={showAll}
            dateChange={(date) => {
              setMemoFromDate(date)
              focusElemnt('memoToDate')
              setIsExpanded(false)
            }}
          />
        </Item>
        <Item sx={{...sx.itemsxGrow, width:'14%'}} className="input--container bookingDatePicker">
          <Datepicker
            id="memoToDate"
            width="100%"
            value={memoToDate}
            statusChecked={tillDate || showAll}
            dateChange={(date) => {
              setMemoToDate(date)
              focusElemnt('memoByDate')
              setIsExpanded(false)
            }}
          />
        </Item>
        <Box sx={{ ...sx.flexbox, flexDirection: 'column', width:'12%',flexWrap:'nowrap' }}>
          <label htmlFor="upload-photo">
            <Checkbox
              id="memoByDate"
              sx={{ padding: 0 }}
              checked={tillDate}
              onChange={(e) => {
                if (e.target.checked) {
                  if (showAll) {
                    setShowAll(false)
                  }
                  setIsShowAllLRs(2);
                }
                setTillDate(e.target.checked)
                setIsExpanded(false)
              }}
              onKeyDown={(e) => {
                navigation1(e, 'memoAllLr', 'memoFromDate')
              }}
            />
            Till Date
          </label>
          <label htmlFor="upload-photo">
            <Checkbox
              id="memoAllLr"
              checked={showAll}
              sx={{ padding: 0 }}
              onChange={(e) => {
                if (e.target.checked) {
                  if (tillDate) {
                    setTillDate(false)
                  }
                  setIsShowAllLRs(1);
                }
                setShowAll(e.target.checked)
                setIsExpanded(false)
              }}
              onKeyDown={(e) => {
                navigation1(e, 'memoNext1', 'memoByDate')
              }}
            />
            Show All Pending LRs
          </label>
        </Box>
        <IconButton
          id="memoNext1"
          style={{ background: cs.secondary.main, borderRadius: '6px' }}
          onClick={()=>getFilter()}
          onKeyDown={(e) => {
            navigation1(e, 'memoSourceCity', 'memoAllLr')
          }}
        >
          <KeyboardArrowRightIcon sx={{ color: cs.white.main }} style={{ fontSize: '25px', margin: '0 10px' }} />
        </IconButton>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2
            id="memoSourceCity"
            nextId="memoDestCity"
            prevId="memoNext1"
            label={'Source City'}
            width="100%"
            searchPlaceholder={`Search Source City`}
            defaultvalue={sourceCity}
            data={sourceCityListData}
            dataKey={`sourceCityList`}
            idKey={`id`}
            resetFlag={resetMainFilter}
            onSelect={(value) => {
              setSourceCity(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownOA
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={'Destination City'}
            defaultvalue={destinationCity?.DestinationCity || ''}
            value={destinationCity?.DestinationCity || ''}
            width="100%"
            searchPlaceholder={`Search Destination City`}
            data={destinationCityListData}
            dataKey={`DestinationCity`}
            idKey={`DestinationCityID`}
            resetFlag={resetMainFilter}
            onSelect={(value) => {
              setDestinationCity(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Button
          id="memoGenerate"
          className="btn add-btn"
          style={{margin:'0px 0px'}}
          variant="contained"
          color="error"
          onClick={handleGenerate}
          onKeyDown={(e) => {
            navigation1(e,'memoToggleFilter','memoDestCity')
          }}
        >
          generate
        </Button>
        <Button
          id="memoToggleFilter"
          variant="text"
          color="primary"
          endIcon={showMore ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          onClick={handleToggle}
          onKeyDown={(e) => { 
          navigation1(e,showMore?'memoPaymentType':'memoPrintBtn','memoGenerate')
          }}
          style={{
            textDecoration: 'underline',
            border: 'none',
            boxShadow: 'none',
            outline: 'none',
            fontWeight: 'bold',
            paddingLeft:'0px 0px',
            fontSize:'12px'
          }}
        >
          {showMore ? 'Less Filters' : 'More Filters'}
        </Button>
      </Box>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start',paddingLeft:'15px', display: showMore ? 'flex' : 'none', paddingTop: 0, paddingBottom: '12px' }}>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoPaymentType" width='100%' nextId="memoChallanNo" prevId="memoToggleFilter" label="Payment Type" defaultvalue={moreFilter?.PaymentType!==''?moreFilter?.PaymentType:''} data={paymentTypeListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, PaymentType: value }) }} reset={() => { setMoreFilter({ ...moreFilter, PaymentType: '' }) }}
          />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoChallanNo"  width='100%' nextId="memoLrNo" prevId="memoPaymentType" label="Challan No" defaultvalue={moreFilter?.ChallanNo || ''} data={challanNoListData.sort(function (a, b) { return a - b })} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, ChallanNo: value }) }} reset={() => { setMoreFilter({ ...moreFilter, ChallanNo: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2  idKey={`idKey`} dataKey={`dataKey`} id="memoLrNo" width='100%' nextId="memoOfflineLr" prevId="memoChallanNo" label="LR No" defaultvalue={moreFilter?.LRNO || ''} data={lrNoListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, LRNO: value }) }} reset={() => { setMoreFilter({ ...moreFilter, LRNO: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoOfflineLr" width='100%' nextId="memoSender" prevId="memoLrNo" label="Offline LR No." defaultvalue={moreFilter?.ManualLRNo || ''} data={offlineLrNoListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, ManualLRNo: value }) }} reset={() => { setMoreFilter({ ...moreFilter, ManualLRNo: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoSender" width='100%' nextId="memoSenderNo" prevId="memoOfflineLr" label="Sender" defaultvalue={moreFilter?.Sender || ''} data={senderListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, Sender: value }) }} reset={() => { setMoreFilter({ ...moreFilter, Sender: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoSenderNo" width='100%' nextId="memoSenderGstin" prevId="memoSender" label="Sender No" defaultvalue={moreFilter?.SenderMobileNo || ''} data={senderMobileNoListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, SenderMobileNo: value }) }} reset={() => { setMoreFilter({ ...moreFilter, SenderMobileNo: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoSenderGstin" width='100%' nextId="memoSenderEmail" prevId="memoSenderNo" label="Sender GSTIN" defaultvalue={moreFilter?.SenderGSTN || ''} data={senderGSTNListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, SenderGSTN: value }) }} reset={() => { setMoreFilter({ ...moreFilter, SenderGSTN: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoSenderEmail" width='100%' nextId="memoReceiver" prevId="memoSenderGstin" label="Sender Email ID" defaultvalue={moreFilter?.SenderEmailID || ''} data={senderEmailIDListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, SenderEmailID: value }) }} reset={() => { setMoreFilter({ ...moreFilter, SenderEmailID: '' }) }} />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownMultiSelectV2 idKey={`idKey`} dataKey={`dataKey`} id="memoReceiver" width='100%' nextId="memoReceiverNo" prevId="memoSenderEmail" label="Receiver" defaultvalue={moreFilter?.RecName || ''} data={recNameListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, RecName: value }) }} reset={() => { setMoreFilter({ ...moreFilter, RecName: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`}  dataKey={`dataKey`} id="memoReceiverNo" width='100%' nextId="memoReceiverEmail" prevId="memoReceiver" label="Receiver No" defaultvalue={moreFilter?.RecMobileNo || ''} data={recMobileNoListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, RecMobileNo: value }) }} reset={() => { setMoreFilter({ ...moreFilter, RecMobileNo: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`}  dataKey={`dataKey`} id="memoReceiverEmail" width='100%' nextId="memoReceiverGstin" prevId="memoReceiverNo" label="Receiver Email ID" defaultvalue={moreFilter?.ReceiverEmailID || ''} data={receiverEmailIDListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, ReceiverEmailID: value }) }} reset={() => { setMoreFilter({ ...moreFilter, ReceiverEmailID: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`}  dataKey={`dataKey`} id="memoReceiverGstin" width='100%' nextId="memoPincode" prevId="memoReceiverEmail" label="Receiver GSTIN" defaultvalue={moreFilter?.ReceiverGSTN || ''} data={receiverGSTNListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, ReceiverGSTN: value }) }} reset={() => { setMoreFilter({ ...moreFilter, ReceiverGSTN: '' }) }} />
        </Item>
        <Item sx={{...sx.itemsx, width:'15%'}}>
          <DropDownMultiSelectV2 idKey={`idKey`}  dataKey={`dataKey`} id="memoPincode" width='100%' nextId="memoNext2" prevId="memoReceiverGstin" label="Pincode" defaultvalue={moreFilter?.PinCode || ''} data={pinCodeListData} resetFlag={resetFilter}
            onSelect={(value) => { setMoreFilter({ ...moreFilter, PinCode: value }) }} reset={() => { setMoreFilter({ ...moreFilter, PinCode: '' }) }} />
        </Item>
        <IconButton
          id="memoNext2"
          style={{ background: cs.secondary.main, borderRadius: '6px' }}
          onKeyDown={(e) => {
            navigation1(e,'memoPrintBtn', 'memoPincode')
          }}
          onClick={filterTableData}
        >
          <KeyboardArrowRightIcon sx={{ color: cs.white.main }} style={{ fontSize: '25px', margin: '0 10px' }} />
        </IconButton>
        <Item sx={sx.itemsx} className="flex-center-all" onClick={() => resetMoreFilter()}>
          {/* {}
         */}
          <RefreshSvg />
        </Item>
      </Box>
    </Box>
  )
}

export default DeliveryMemoFilter
